import React, {useRef, useState} from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {useAuth} from '../../../contexts/AuthContext';

const styles = {
  paper: {
    marginTop: '128px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  message: {
    color: 'green'
  },
  error: {
    color: 'red'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: '8px',
  },
  submit: {
    margin: 'auto',
  }
};

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [error, setError] = useState();
  const [message, setMessage] = useState();
  const emailRef = useRef();


  const handleSubmit = (e) => {
    setError('');
    e.preventDefault();
    resetPassword(emailRef.current.value).then(()=>{
      setMessage("Check your email inbox for further instructions");
    }, (error) => {
      setError(error.message || 'An error occurred. Please try again.');
    });
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div style={styles.paper}>
        <Typography component="h1" variant="h5">
          Forgot your Password?
        </Typography>
        <form style={styles.form} onSubmit={handleSubmit} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            inputRef={emailRef}
          />
          { message && 
          <Typography style={styles.message} component="h5">
            {message}
          </Typography>
          }
          { error && 
          <Typography style={styles.error} component="h5">
            {error}
          </Typography>
          }
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            style={styles.submit}
          >
            Reset Password
          </Button>
          <Grid container>
            <Grid size="grow">
              <Link href="/login" variant="body2">
                Login
              </Link>
            </Grid>
            <Grid>
              <Link href="/signup" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
}